import { render, staticRenderFns } from "./TheSignatureDocLink.vue?vue&type=template&id=bc151096&scoped=true&"
import script from "./TheSignatureDocLink.vue?vue&type=script&lang=js&"
export * from "./TheSignatureDocLink.vue?vue&type=script&lang=js&"
import style0 from "./TheSignatureDocLink.vue?vue&type=style&index=0&id=bc151096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc151096",
  null
  
)

export default component.exports